






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class I extends Vue {
    @Prop() readonly name: string | undefined;
}
